import { render, staticRenderFns } from "./SidebarLabel.vue?vue&type=template&id=001f8486&scoped=true"
import script from "./SidebarLabel.vue?vue&type=script&lang=js"
export * from "./SidebarLabel.vue?vue&type=script&lang=js"
import style0 from "./SidebarLabel.vue?vue&type=style&index=0&id=001f8486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001f8486",
  null
  
)

export default component.exports